<form class="card mt-2" *ngIf="canEdit">
  <div class="card-body">
    <div class="float-right">
      <button *ngIf="canEditOpenEnrollment" (click)="editEnrollmentHelpInformation()" class="btn btn-secondary mr-2">Edit Enrollment Help Information</button>
      <button *ngIf="canEditOpenEnrollment" (click)="editBenefitSettings()" class="btn btn-secondary mr-2">Edit Open Enrollment</button>
      <button *ngIf="canEdit" class="btn btn-primary pointer" routerLink="/benefits-management/benefit-plan/addit">New Plan</button>
    </div>
    <h2 class="mb-3">Benefits Plans</h2>

    <h5>Filter</h5>
    <div class="row mb-1" >
      <div class="col-6">
        <div class="row mb-1">
          <div class="col-4 d-flex align-items-center">
            <h6>Plan Name:</h6>
          </div>
          <div class="col-8 ">
            <input type="text" [(ngModel)]="planNameFilter" class="form-control" (ngModelChange)="changedFilters()" [ngModelOptions]="{standalone: true}">
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-4 d-flex align-items-center">
            <h6>Carrier:</h6>
          </div>
          <div class="col-8 ">
            <input type="text" [(ngModel)]="carrierFilter" class="form-control" (ngModelChange)="changedFilters()" [ngModelOptions]="{standalone: true}">
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-4 d-flex align-items-center">
            <h6>Active:</h6>
          </div>
          <div class="col-8 ">
            <p-selectButton styleClass="w-100" [options]="yesNoAllOptions" [(ngModel)]="activeFilter" (ngModelChange)="changedFilters()" [ngModelOptions]="{standalone: true}"></p-selectButton>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-4 d-flex align-items-center">
            <h6>Period:</h6>
          </div>
          <div class="col-8 ">
            <p-select styleClass="app-select  w-100" [options]="datesOptions" placeholder="Select ..." [(ngModel)]="periodDateOptionFilter" (ngModelChange)="changedFilters()" [ngModelOptions]="{standalone: true}"></p-select>

            <p-datepicker *ngIf="periodDateOptionFilter==0"
                        inputStyleClass="form-control "
                        [monthNavigator]="true"
                        [yearNavigator]="true"
                        styleClass="w-75"
                        panelStyleClass="calendarPanel"
                        [hourFormat]="12"
                        [yearRange]="'2010:2100'"
                        [showTime]="false"
                        [selectionMode]="'range'"
                        [(ngModel)]="periodDateFilter" (ngModelChange)="changedFilters()" [ngModelOptions]="{standalone: true}"
                        dataType="string"></p-datepicker>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-4 d-flex align-items-center">
            <h6>Date Enrolled:</h6>
          </div>
          <div class="col-8 ">
            <p-select styleClass="app-select  w-100" [options]="dateEnrolledOptionList" optionLabel="text" [(ngModel)]="dateEnrolledRange" (ngModelChange)="changedEnrolledDateRange()" [ngModelOptions]="{standalone: true}"></p-select>

            <p-datepicker *ngIf="isCustomDateEnrolled"
                        inputStyleClass="form-control "
                        [monthNavigator]="true"
                        [yearNavigator]="true"
                        styleClass="w-75"
                        panelStyleClass="calendarPanel"
                        [hourFormat]="12"
                        [yearRange]="'2010:2100'"
                        [showTime]="false"
                        [selectionMode]="'range'"
                        [(ngModel)]="dateEnrolledCustomFilter" (ngModelChange)="changedDateEnrolledCustomFilter()" [ngModelOptions]="{standalone: true}"
                        dataType="string"></p-datepicker>
          </div>
        </div>

      </div>

    </div>

    <i *ngIf="loadingBenefitPlanList || loadingExcelDownload || downloadingZipFile" class="material-icons rotate text-muted">loop</i>
    <p-table  #myTable [value]="benefitPlanList?.result" [responsive]="true"
    [paginator]="true" [rows]="20" [totalRecords]="benefitPlanList?.totalRecords" [lazy]="true"
    (onLazyLoad)="loadPage($event)">
        <ng-template pTemplate="header">
            <tr>
                <th width="90px"></th>
                <th [pSortableColumn]="'PlanName'" >Plan
                   <p-sortIcon [field]="'PlanName'"></p-sortIcon></th>
                    <th [pSortableColumn]="'PlanType'">Type
                      <p-sortIcon [field]="'PlanType'"></p-sortIcon>
                    </th>

                <th [pSortableColumn]="'Carrier'">Carrier
                  <p-sortIcon [field]="'Carrier'"></p-sortIcon>
                </th>

                <th [pSortableColumn]="'Active'"  width="100px" class="text-center">Active
                  <p-sortIcon [field]="'Active'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'StartDate'" width="120px" class="text-center">
                  Period
                  <p-sortIcon [field]="'StartDate'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'TotalEmployeeEnrolled'" width="190px" class="text-right">Enrollments (Total)
                  <p-sortIcon [field]="'TotalEmployeeEnrolled'"></p-sortIcon>
                </th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-benefitsPlan>
            <tr >
                <td>
                  <span class="pointer mr-2" *ngIf="canEdit"   (click)="editBenefitsPlan(benefitsPlan)"><i title="Edit Benefits Plan" class="fas fa-edit"></i></span>
                  <span class="pointer mr-2" *ngIf="canEdit"   (click)="deleteBenefitsPlan(benefitsPlan)"><i title="Deactivate Benefits Plan" class="fas fa-trash"></i></span>
                </td>
                <td>
                    <span class="ui-column-title">Plan Name</span>
                  {{benefitsPlan.planName }}
                </td>

                <td>
                  <span class="ui-column-title">Plan Name</span>
                {{benefitsPlan.benefitPlanTypeLabel }}
              </td>
                <td>
                    <span class="ui-column-title">Carrier</span>
                  {{benefitsPlan.carrier }}
                </td>

                <td  class="text-center">
                  <span class="ui-column-title">Active</span>
                {{benefitsPlan.active?'Yes':'No' }}
              </td>
                <td class="text-center">
                  <span class="ui-column-title">Period</span>
                  {{getPeriod(benefitsPlan)}}
                </td>

                <td class="text-right">
                  <span class="ui-column-title">Employees Enrolled</span>
                  {{benefitsPlan.enrolledEmployees}} ({{benefitsPlan.totalEmployeeEnrolled}})
                  <span class="pointer mr-2" *ngIf="showExport(benefitsPlan)" (click)="exportEnrollments(benefitsPlan)"><i title="Export xls with enrollments" class="fas fa-file-excel" style="color: green;"></i></span>
                  <span class="pointer mr-2" *ngIf="showExport(benefitsPlan)" (click)="downloadSignDocumentZipFile(benefitsPlan)"><i title="Download signed forms" class="fas fa-file-archive" style="color: navy;"></i></span>
                </td>

            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
          Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
        </ng-template>
        <ng-template pTemplate="paginatorright">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
                <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
                <p-dropdown 
                    [options]="dropdownOptions()" 
                    optionLabel="label" 
                    optionValue="value"
                    [ngModel]="myTable.rows" 
                    (onChange)="myTable.rows = $event.value; myTable.reset()">
                </p-dropdown>
            </div>
        </ng-template>
    </p-table>
  </div>
</form>

<p-confirmDialog></p-confirmDialog>
<app-edit-benefit-settings></app-edit-benefit-settings>
<app-enrollment-edit-help-info></app-enrollment-edit-help-info>
